import { useFormikContext } from 'formik'
import { getErrorMessage, validateField } from 'core/common/utils/validation'
import EditorField from './EditorField'

function ProductTextEditor({ hasEditorTips, onNext, onReload, custom, hasHtmlFormat, onChange }) {
  const { errors, setFieldTouched, setFieldValue, submitCount, touched, values, initialValues } =
    useFormikContext()

  const error = validateField('description', errors, touched, submitCount > 0)
  const helperText = getErrorMessage('description', errors, touched)

  return (
    <EditorField
      onNext={onNext}
      onReload={onReload}
      error={error}
      helperText={helperText}
      setFieldTouched={setFieldTouched}
      setFieldValue={setFieldValue}
      value={values.description}
      hasEditorTips={hasEditorTips}
      custom={custom}
      hasHtmlFormat={hasHtmlFormat}
      onChange={onChange}
      initialValues={initialValues}
    />
  )
}

export default ProductTextEditor
